import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { InputComponent } from '../../components/InputComponent';
import { TablaDinamica } from '../../components/TablaDinamica';
import { useLazyParams } from '../../hooks/useLazyParams';
import { AccionistaSocio } from '../../models/AccionistaSocio';
import { AccionistaSocioService } from '../../service/AccionistaSocioService';
import { confirmDialog } from 'primereact/confirmdialog';
import { InputActividadEconomica } from '../../components/ui/Formularios/InputActividadEconomica';

import * as generic from '../../components/Generico';

export const AccionistaSocios = ({ toast, tipo, id, permss, tipoFrmEmpresa, soloLectura }) => {
    const omodel = new AccionistaSocio();
    const defaultValues = generic.funDefault(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, clearErrors, getValues } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const accionistaSocioSrv = new AccionistaSocioService();
    const [dialogAccionistaSocio, setDialogAccionistaSocio] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [padreId, setPadreId] = useState(null);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);
    const tablaAccionistas = useLazyParams({ modelo: omodel.model });
    const { inDrop, inText } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyAccionistaSocio();
        // eslint-disable-next-line
    }, [tablaAccionistas.lazyParams, id]);

    const loadLazyAccionistaSocio = () => {
        tablaAccionistas.setLoading(true);
        const _params = { ...tablaAccionistas.lazyParams, idj: id, tipo: tipo };
        accionistaSocioSrv.getAccionistaSocio({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaAccionistas.setTotalRecords(res.data.total);
            tablaAccionistas.setData(res.data.registros);
        }).finally(() => {
            tablaAccionistas.setLoading(false)
        });
    };

    const openNew = (e, padre = null) => {
        setPadreId(padre);
        setEsRuc(false);
        setEsCedula(false);
        clearErrors();

        if (catalogos == null) {
            accionistaSocioSrv.newAccionistaSocio({ iniciar: 1, tipo, tipoFrmEmpresa }).then(res => {
                setCatalogos(res.data);
                setDialogAccionistaSocio(true);
                reset(defaultValues);
            });
        } else {
            setDialogAccionistaSocio(true);
            reset(defaultValues);
        }
    };

    const hideDialog = () => { setDialogAccionistaSocio(false); };

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.ruc = catalogos?.ruc;
        if (padreId != null) {
            data.padreId = padreId;
        }
        const request = getValues('id') == null
            ? accionistaSocioSrv.newAccionistaSocio(data)
            : accionistaSocioSrv.editarAccionistaSocio(data);

        request.then(res => {
            setDialogAccionistaSocio(false);
            loadLazyAccionistaSocio();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    };

    const editAccionista = (data) => {
        const iniciar = catalogos == null ? 1 : 0;
        accionistaSocioSrv.getAccionista(data.id, tipo, id, iniciar, { tipoFrmEmpresa }).then(res => {
            let _cats = catalogos;
            if (iniciar === 1) {
                setCatalogos(res.data.catalogo);
                _cats = res.data.catalogo;
            }
            const lista = {
                tipo_accionista_socio: _cats.tipo_accionista_socio,
                tipo_identificacion: _cats.tipo_identificacion,
                nacionalidad: _cats.nacionalidad
            };
            const _accionista = res.data.accionista;
            Object.keys(lista).forEach(function (key) {
                if (_accionista[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _accionista[key]) {
                            _accionista[key] = element;
                        }
                    });
                }
            });

            setEsCedula(_accionista.tipo_identificacion?.cat_id === _cats?.cedula?.cat_id);
            setEsRuc(_accionista.tipo_identificacion?.cat_id === _cats?.ruc?.cat_id);

            if (res.data.actividad_economica) {
                _accionista['actividad_economica'] = res.data.actividad_economica;
            }
            reset(generic.renewValues(_accionista, omodel.model));
            setDialogAccionistaSocio(true);
        });
    };

    const onChangeTipo = (e) => {
        const isRuc = e.value?.cat_id === catalogos?.ruc?.cat_id;
        const isCedula = e.value?.cat_id === catalogos?.cedula?.cat_id;
        setEsRuc(isRuc);
        setEsCedula(isCedula);
        clearErrors('identificacion');
    };

    // Validación de Cédula / RUC de Ecuador
    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;
    const reglaValidacion = (val) => {
        if (!tipoDoc || !val) return true;
        if (generic.validarIdentificacionEcuador) {
            return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
        }
        return true;
    };

    const confirmDelete = (data) => {
        confirmDialog({
            message: '¿Está seguro de eliminar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarAccionista(data)
        });
    };

    const eliminarAccionista = (data) => {
        accionistaSocioSrv.eliminarAccionista(data.id, tipo, id).then(res => {
            loadLazyAccionistaSocio();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editAccionista(registroSeleccionado) }] }];
        }

        const items = [];
        if (permss?.actualizar) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editAccionista(registroSeleccionado) });
        }
        if (registroSeleccionado?.activado) {
            items.push({ label: 'Consignar accionista', icon: 'pi pi-users', command: () => openNew(null, registroSeleccionado.id) });
        }
        if (permss?.eliminar) {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado) });
        }
        return [{ label: 'Opciones', items: items }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_accionista" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Accionistas / Socios
            </span>
        </div>
    );

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    };

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_accionista" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaAccionistas} datos={tablaAccionistas.data} totalRegistros={tablaAccionistas.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogAccionistaSocio} header={soloLectura ? "Ver Accionista / Socio" : (getValues('id') == null ? "Nuevo Accionista / Socio" : "Editar Accionista / Socio")}
                modal className="p-fluid modal-ssize" style={{ width: '850px', maxWidth: '95vw' }} onHide={hideDialog}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="formgrid grid">
                        <div className="col-12 mb-2">
                            <span className="text-800 font-bold text-base flex align-items-center gap-2">
                                <i className="pi pi-users text-primary"></i>
                                ACCIONISTA / SOCIO
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>
                        {inDrop('tipo_accionista_socio', catalogos?.tipo_accionista_socio, { lab: omodel.optionLabel }, 4)}
                        {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 4)}
                        {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 4)}
                        <div className="col-12 mt-3 mb-2">
                            <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                                <i className="pi pi-user text-primary"></i>
                                DATOS PERSONALES
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>

                        {esRuc ? (
                            inText('razon_social', { icon: 'pi pi-briefcase' }, 12)
                        ) : (
                            <>
                                {inText('nombres', { icon: 'pi pi-user' }, 6)}
                                {inText('apellidos', { icon: 'pi pi-user-edit' }, 6)}
                            </>
                        )}

                        <div className="col-12 mt-3 mb-2">
                            <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                                <i className="pi pi-briefcase text-primary"></i>
                                ACTIVIDAD Y CARGO
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>

                        {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 6)}
                        {inText('cargo', { icon: 'pi pi-briefcase' }, 6)}

                        <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />

                    </div>

                    <div className="flex justify-content-end mt-4">
                        {soloLectura ? (
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                        ) : (
                            generic.buttonsForms(hideDialog)
                        )}
                    </div>
                </form>
            </Dialog>
        </>
    );
};